import api, { ClientErrorPayload } from "./services/api";

let isLoggingError = false;
// const lastErrors = new Set<string>();

export function safeLog(payload: Partial<ClientErrorPayload>) {
  // Prevent recursion
  if (isLoggingError) return;

  // Deduplicate (same error message)
  // const signature = `${payload.type}:${payload.message}`;
  // if (lastErrors.has(signature)) return;

  // lastErrors.add(signature);
  // setTimeout(() => lastErrors.delete(signature), 10_000); // keep 10s

  try {
    isLoggingError = true;

    // 🚀 Fire-and-forget
    api.logFrontendError(payload).catch(() => {
      console.log("error logging failed");
      // Swallow logging errors
    });
  } catch {
    // Never throw from logger
  } finally {
    isLoggingError = false;
  }
}

// src/error-logger.ts
export function initClientErrorLogger() {
  // Test avec setTimeout(() => { dede.test() }, 0) dans la console
  window.onerror = (message, source, lineno, colno, error) => {
    const msg = String(message);

    // Auto-reload on chunk/module load error (often happens after a new deployment)
    if (msg.includes("Failed to fetch dynamically imported module") || msg.includes("Importing a module script failed")) {
      console.warn("Module load error detected. Reloading page for recovery...");
      window.location.reload();
      return;
    }

    safeLog({
      type: "error",
      message: msg,
      source,
      lineno,
      colno,
      stack: error?.stack,
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    });
  };

  // Promises non catchées
  // Test avec Promise.reject("test promise") dans la console
  window.addEventListener("unhandledrejection", (event) => {
    const msg = event.reason?.message || String(event.reason);

    // Some browsers report module load failures via unhandledrejection
    if (msg.includes("Failed to fetch dynamically imported module") || msg.includes("Importing a module script failed")) {
      console.warn("Module load error (promise) detected. Reloading page for recovery...");
      window.location.reload();
      return;
    }

    safeLog({
      type: "unhandledrejection",
      message: msg,
      stack: event.reason?.stack,
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    });
  });
}
